import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Mic } from "lucide-react";

export const PublicLayout = ({ children }) => (
    <div className="min-h-screen bg-bg text-ink font-body flex flex-col">
        <header className="border-b border-border-line bg-bg/90 backdrop-blur sticky top-0 z-30">
            <div className="container-app h-16 flex items-center justify-between">
                <Link to="/" data-testid="public-logo-link"><Logo /></Link>
                <nav className="flex items-center gap-2">
                    <Link to="/login" data-testid="public-nav-login" className="btn-ghost text-sm">Accedi</Link>
                    <Link to="/register" data-testid="public-nav-register" className="btn-primary text-sm">Iscriviti</Link>
                </nav>
            </div>
        </header>
        <main className="flex-1">{children}</main>
        <Footer />
    </div>
);

export const Footer = () => (
    <footer className="border-t border-border-line bg-bg">
        <div className="container-app py-10 grid sm:grid-cols-2 md:grid-cols-4 gap-8 text-sm">
            <div>
                <Logo size={36} />
                <p className="text-muted mt-4 text-xs leading-relaxed">Il network del podcast Voci di Imprese. Connette imprenditori e liberi professionisti italiani.</p>
            </div>
            <div>
                <div className="font-medium text-ink uppercase tracking-widest text-xs">Network</div>
                <ul className="mt-3 space-y-2 text-muted">
                    <li><Link to="/" className="hover:text-bordeaux transition-colors">Home</Link></li>
                    <li><Link to="/login" className="hover:text-bordeaux transition-colors">Accedi</Link></li>
                    <li><Link to="/register" className="hover:text-bordeaux transition-colors">Iscriviti</Link></li>
                </ul>
            </div>
            <div>
                <div className="font-medium text-ink uppercase tracking-widest text-xs">Legale</div>
                <ul className="mt-3 space-y-2 text-muted">
                    <li><Link data-testid="footer-privacy" to="/privacy-policy" className="hover:text-bordeaux transition-colors">Privacy Policy</Link></li>
                    <li><Link data-testid="footer-cookie" to="/cookie-policy" className="hover:text-bordeaux transition-colors">Cookie Policy</Link></li>
                    <li><Link data-testid="footer-terms" to="/terms" className="hover:text-bordeaux transition-colors">Termini e Condizioni</Link></li>
                </ul>
            </div>
            <div>
                <div className="font-medium text-ink uppercase tracking-widest text-xs">Podcast</div>
                <ul className="mt-3 space-y-2 text-muted">
                    <li><a href="https://open.spotify.com/show/3eHlxijuL70U3ihV5PVajR" target="_blank" rel="noreferrer" className="hover:text-bordeaux transition-colors flex items-center gap-1"><Mic size={12} /> Ascolta su Spotify</a></li>
                </ul>
            </div>
        </div>
        <hr className="gold-divider" />
        <div className="container-app py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-soft">
            <div>© 2026 Voci di Imprese — network.vocidiimprese.com</div>
            <div>Tutti i diritti riservati</div>
        </div>
    </footer>
);
